import { ReactNode } from "react";
import { Footer } from "./footer";
import { Navbar, NavbarProps } from "./navbar";

interface LandingLayoutProps extends NavbarProps {
  children: ReactNode;
  /** Hide the footer's "Your First Assessment is on US" CTA (for pages with their own CTA). */
  hideFooterCta?: boolean;
}

const LandingLayout: React.FC<LandingLayoutProps> = ({ children, active, hideFooterCta }) => {
  return (
    <>
      <Navbar active={active} />
      <main>{children}</main>
      <Footer showCta={!hideFooterCta} />
    </>
  );
};

export { LandingLayout };
